import type * as BlockQuote from '../types/BlockQuote'
import { imageParser } from '../props/parsers/Image'

export default function (rawComponent: BlockQuote.Raw): BlockQuote.Parsed {
  const { image, ...rest } = rawComponent.blockQuote

  return {
    name: 'BlockQuote',
    props: {
      ...imageParser(image),
      ...rest,
    },
  }
}
